import axios from 'axios';

import { capitalize, generateServiceBaseURL } from '@/utils/general';
import { requestInterceptor } from '@/plugins/keycloak';

export function autoComplete(i18n, store) {
  const service = axios.create({
    baseURL: generateServiceBaseURL('pv/autocomplete/pruefungsverwaltung')
  });

  service.interceptors.request.use(requestInterceptor);

  service.interceptors.response.use((response) => response, (error) => {
    if (error.response.status !== 404) {
      const { data } = error.response;
      if (data.translation && i18n.te(data.translation.key)) {
        data.message = i18n.t(data.translation.key, data.translation.params);
      }
      store.commit('notice/add', {
        message: data.message ? `${capitalize(data.message)}.` : 'Es ist ein Fehler beim Abruf des Service "Prüfungsverwaltung" aufgetreten. Bitte versuchen Sie es später erneut.',
        type: 'error'
      });
    }

    return error.response;
  });

  const searchExams = (fieldName, search) => service({
    method: 'post',
    data: {
      fieldName,
      search
    }
  });

  return {
    searchExams
  };
}
